<script setup>
import { computed, nextTick, ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { useStore } from 'dashboard/composables/store';
import Dialog from 'dashboard/components-next/dialog/Dialog.vue';
import PlatformAnnouncementsAPI from 'dashboard/api/platformAnnouncements';

const store = useStore();
const { t } = useI18n();

const dialogRef = ref(null);
const announcements = ref([]);
const acknowledging = ref(false);

const currentUserId = computed(() => store.getters.getCurrentUser?.id);
const currentAnnouncement = computed(() => announcements.value[0] || null);

const openCurrent = async () => {
  if (!currentAnnouncement.value) return;

  await nextTick();
  dialogRef.value?.open();
};

const loadAnnouncements = async () => {
  if (!currentUserId.value) return;

  try {
    const { data } = await PlatformAnnouncementsAPI.get();
    announcements.value = Array.isArray(data) ? data : [];
    openCurrent();
  } catch {
    announcements.value = [];
  }
};

const acknowledge = async () => {
  const announcement = currentAnnouncement.value;
  if (!announcement || acknowledging.value) return;

  acknowledging.value = true;
  try {
    await PlatformAnnouncementsAPI.acknowledge(announcement.id);
    announcements.value = announcements.value.filter(
      item => item.id !== announcement.id
    );
    dialogRef.value?.close();
    openCurrent();
  } finally {
    acknowledging.value = false;
  }
};

watch(
  currentUserId,
  userId => {
    if (userId) loadAnnouncements();
  },
  { immediate: true }
);
</script>

<template>
  <Dialog
    ref="dialogRef"
    type="edit"
    width="lg"
    :title="currentAnnouncement?.title || ''"
    :confirm-button-label="t('PLATFORM_ANNOUNCEMENT.CONFIRM')"
    :show-cancel-button="false"
    :close-on-outside-click="false"
    :is-loading="acknowledging"
    @confirm="acknowledge"
  >
    <p
      v-if="currentAnnouncement"
      class="mb-0 text-sm text-n-slate-12 whitespace-pre-wrap"
    >
      {{ currentAnnouncement.body }}
    </p>
  </Dialog>
</template>
